import { StateCreator } from 'zustand';
import { SimpleProductInfo } from '@/types/products/simple-product-info';
import { WithQuantity } from '@/types/products/with-quantity';

export type UpsellDialogSlice = {
  upsellDialog: {
    isOpen: boolean;
    products: WithQuantity<SimpleProductInfo>[];
  };
  openUpsellDialog: (product: WithQuantity<SimpleProductInfo>) => void;
  closeUpsellDialog: () => void;
};

export const createUpsellDialogSlice: StateCreator<UpsellDialogSlice> = set => ({
  upsellDialog: {
    isOpen: false,
    products: [],
  },
  // Accumulate every added product so the dialog can list all items added in
  // this session — e.g. a recipe's "buy all ingredients" fires several adds at
  // once, and previously only the first one showed (the rest were swallowed by
  // an "already open" guard). Adding a product that's already listed merges
  // into the existing row and bumps its quantity instead of duplicating it.
  openUpsellDialog: product =>
    set(state => {
      const existingIndex = state.upsellDialog.products.findIndex(p => p.id === product.id);
      const products =
        existingIndex === -1
          ? [...state.upsellDialog.products, product]
          : state.upsellDialog.products.map((p, index) =>
              index === existingIndex ? { ...p, quantity: p.quantity + product.quantity } : p,
            );

      return { upsellDialog: { isOpen: true, products } };
    }),
  closeUpsellDialog: () =>
    set(() => ({
      upsellDialog: { isOpen: false, products: [] },
    })),
});
